<template>
  <section>
    <div class="portfolio">
      <ScrollDown />
      <div class="dashedLine extended"></div>
      <NumberContainer num="2" />
      <h3 class="large u-space-top--xlarge ericTransEffect">
        My <span>Portfolio</span>.<br />
      </h3>
      <div class="grid">
        <div class="row">
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/aetna.jpg"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top ericTransEffect">
              Working on a digital style guide for Aetna. Utilizes react to
              build components for many different parties to have a central
              reference.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/mrp.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              A site created for MRP Realty in Downtown Manhattan.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/longfellow.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              A site for Longfellow. They invest capital for innovation growth
              in real estate.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/rxr.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              Among New York Tri-State area’s leading real estate companies with
              a portfolio of 92 major building projects.
            </p>
          </div>
        </div>
        <div class="row">
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/31w52nd.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              31 West 52nd Street is a first-class office tower ideally located
              in Midtown Manhattan.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/beatty.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              Harbor Point is the forefront in sustainability and innovation for
              Baltimore.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/1325aoa.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              Located in Manhattan, 1325 AOA puts mid in midtown.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/mit.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              Kendall Square is a new high tech hub vetted by MIT and Harvard.
              This site features their new hub.
            </p>
          </div>
        </div>
        <div class="row">
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/zerobond.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              A workspace in Brooks Brothers Landmark NY.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/s.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              A temp site featuring Boston's Seaport Square. Home of influential
              global tech companies.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/asai.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              A wordpress site co-developed as the backend dev for Neoscape.
              ASAI does work such as events relating to artists.
            </p>
          </div>
          <div
            class="item col-xs-12 col-xs-offset-0 col-sm-6 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-0 u-space-top--large ericTransEffect"
          >
            <img
              src="../assets/portsubicons/hvc.png"
              alt="Lorem ipsum dolor sit amet"
            />
            <p class="u-space-top">
              Victory Center is a new building to the Dallas skyline's vibrant
              urban districts.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollDown from "@/components/ScrollDown.vue";
import NumberContainer from "@/components/NumberContainer.vue";

export default {
  name: "home",
  components: {
    ScrollDown,
    NumberContainer
  }
};
</script>

<style scoped lang="scss">
.portfolio {
  max-width: 1000px;
  margin: 40px auto 0 auto;
  .grid {
    margin: 0 20px;
    & .item {
      & > img {
        width: 100%;
      }
    }
  }
}
</style>
